var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"loading_component"},[_c('div',{staticClass:"loadingBox"},[_c('div',{staticClass:"loading_animate"}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.text))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }